import { selectProduct } from "@/store/slices/product";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "./rating-badge.module.scss";
import endpoints from "@/api/endpoints";
import httpClient from "@/api/http-client";

const ProductDetailsRatingBadge = () => {
  const productState = useSelector(selectProduct);
  const [reviewSummarys, setReviewSummarys] = useState<any>(null);

  useEffect(() => {
    const reviewSummary = async () => {
      try {
        const { data } = await httpClient.get(
          endpoints.feedback.feedbackSummary(productState.data?.slug)
        );
        setReviewSummarys(data);
      } catch (error) {
        console.error("Error fetching review summary", error);
      }
    };
    if (productState.data?.slug) {
      reviewSummary();
    }
  }, [productState.data?.slug]);

  if (!productState.data) {
    return <></>;
  }

  const hasRating =
    reviewSummarys?.averageRating || productState.data?.avarageRating;

  const hasTotalRatings =
    productState.data?.totalRatings > 0 || reviewSummarys?.totalRatings > 0;

  if (!hasRating || !hasTotalRatings) {
    return <></>;
  }

  return (
    <div className="w-100">
      <div className={styles.ratingBadge}>
        <span className={styles.rating}>
          {reviewSummarys?.averageRating || productState.data?.avarageRating}{" "}
          <span className={styles.star}>★</span>
        </span>

        <span className={styles.divider}></span>

        <span className={styles.totalRatings}>
          {productState.data?.totalRatings || reviewSummarys?.totalRatings}{" "}
          Ratings
        </span>
      </div>
    </div>
  );
};

export default ProductDetailsRatingBadge;
